import { Coordinate } from 'ol/coordinate'

/**
 * Type guard to check if a value is a valid OpenLayers Coordinate.
 * An OL Coordinate is an array of at least two numbers.
 * @param value The value to check.
 * @returns True if the value is a Coordinate, otherwise false.
 */
export function isCoordinate(value: any): value is Coordinate {
  return Array.isArray(value) && value.length >= 2 && typeof value[0] === 'number' && typeof value[1] === 'number'
}

/**
 * Type guard to check if a value is a valid OpenLayers Polygon coordinate array.
 * An OL Polygon's coordinates have a structure of Coordinate[][].
 * @param value The value to check.
 * @returns True if the value has a Polygon's coordinate structure, otherwise false.
 */
export function isPolygonCoordinates(value: any): value is Coordinate[][] {
  return Array.isArray(value) && Array.isArray(value[0]) && (value[0].length === 0 || isCoordinate(value[0][0]))
}
